module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TrueFalse"
  }, [_c('img', {
    staticClass: "TrueFalse-image",
    attrs: {
      "src": _vm.content.image
    }
  }), _vm._v(" "), (_vm.content.text) ? _c('p', {
    staticClass: "TrueFalse-question",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "TrueFalse-options"
  }, _vm._l((['True', 'False']), function(option) {
    return _c('button-component', {
      key: option,
      staticClass: "TrueFalse-option",
      nativeOn: {
        "click": function($event) {
          _vm.submit($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option) + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2370b80"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/TrueFalse.vue
// module id = 823
// module chunks = 1